import { resources } from '../../utils/resources';
import './Swap.css';
import { useUI } from '../../hooks/useUI';
import { useState, useEffect } from 'react';
import { swapBuybackBalance } from '../../utils/api';

const Swap = () => {
    const { userData } = useUI();

    // Функция для нахождения уровня по сумме
    function getTierByAmount(amount, swap_tier) {
        if (!swap_tier || !Array.isArray(swap_tier.levels)) {
            throw new Error('Некорректная структура swap_tier');
        }

        const tier = swap_tier.levels.find(level =>
            amount >= level.minamount && amount <= level.maxamount
        );

        return tier || null;
    }

    const tier = getTierByAmount(userData.user_main_balance, userData.swap_tier);

    const [inputValue, setInputValue] = useState('');
    const [isInputValid, setIsInputValid] = useState(true);
    const [calculatedAmount, setCalculatedAmount] = useState(null);

    // Функция для проверки, что инпут заполнен
    const areInputsFilled = () => {
        return inputValue.trim() !== '';
    };

    // Функция для форматирования числа
    function formatNumber(num) {
        num = Math.ceil(num * 100) / 100; // Округляем в большую сторону с точностью до 2 знаков

        if (num >= 1_000_000) {
            const value = Math.ceil((num / 1_000_000) * 10) / 10;
            return Number.isInteger(value) ? value.toString() + 'M' : value.toFixed(1) + 'M';
        } else if (num >= 1_000) {
            const value = Math.ceil((num / 1_000) * 10) / 10;
            return Number.isInteger(value) ? value.toString() + 'K' : value.toFixed(1) + 'K';
        } else {
            return Math.ceil(num).toString();
        }
    }

    function formatNumberForXlmResult(num) {
        // Если число больше 1 000 000 (миллионы)
        if (num >= 1_000_000) {
            const value = num / 1_000_000;
            return value.toFixed(2) + 'M'; // Форматируем до 2 знаков после запятой
        } 
        // Если число больше 1 000 (тысячи)
        else if (num >= 1_000) {
            const value = num / 1_000;
            return value.toFixed(2) + 'K'; // Форматируем до 2 знаков после запятой
        } 
        // Если число меньше 1 000
        else {
            return num.toString(); // Просто возвращаем число как есть
        }
    }
    

    // Обработчик изменения значения инпута
    const handleInputChange = (e) => {
        const value = e.target.value;

        // Разрешаем только числа и одну точку
        if (!/^(\d*\.?\d*)$/.test(value)) {
            return; // Игнорируем ввод, если это не число или несколько точек
        }

        // Преобразуем значение в число
        const numberValue = parseFloat(value);

        // Проверка, что сумма не больше чем user_buy_back_balance
        if (numberValue > userData.user_buy_back_balance) {
            setIsInputValid(false);
        } else {
            setIsInputValid(true);
        }

        // Обновляем значение инпута
        setInputValue(value);

        // Пересчитываем результат
        const result = numberValue * tier.percent;
        setCalculatedAmount(result);
    };

    // Обработчик нажатия клавиши
    const handleKeyDown = (e) => {
        if (e.key === 'Enter') {
            main();
        }
    };

    // Основная функция отправки
    const main = async () => {
        const numberValue = parseFloat(inputValue);

        // Проверка условий перед отправкой
        if (areInputsFilled() && numberValue > 0 && numberValue <= userData.user_buy_back_balance) {
            setIsInputValid(true);
            const result = await swapBuybackBalance(window.Telegram.WebApp.initData, numberValue);

            // Если есть ошибка или status не "Success", обводим инпут красной рамкой
            if (result.status == 'Success') {
                window.location.href = window.location.href;
            } else if (result.status != 'Success') {
                setIsInputValid(false);
                console.log('Ошибка: ', result.message);
            } else {
                // Запрос успешно выполнен
                console.log('Запрос отправлен, результат:', result);
            }
        } else {
            setIsInputValid(false); // Устанавливаем ошибку, если условия не выполнены
            console.log('Ошибка: сумма должна быть больше 0 и меньше или равна балансу');
        }

        document.activeElement.blur(); // Снимаем фокус с инпута
    };

    return (
        <div className="swapPage">
            <div className="container">
                <div className="swapPage__balance">
                    <div className="swapPage__rateBalance" style={{ backgroundImage: `url(${resources.images.Timersection})` }}>
                        <span className="swapPage__titleRateBalance">Current rate</span>
                        <div className="swapPage__blockRateBalance">
                            <span className="swapPage__textBlockRateBalance">1 BOM = {tier.percent} XLM</span>
                        </div>
                    </div>
                    <div className="swapPage__BuyBackBalance" style={{ backgroundImage: `url(${resources.images.Container2})` }}>
                        <div className="swapPage__contentBuyBackBalance">
                            <span className="swapPage__titleBuyBackBalance">Buy Back Balance</span>
                            <div className="swapPage__amountBuyBackBalance">
                                <img src={resources.icons.bag} className="swapPage__iconAmountBuyBackBalance rewardCard__valueIcon" />
                                <span className="swapPage__numberAmountBuyBackBalance">{formatNumber(userData.user_buy_back_balance)}</span>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="swapPage__converter">
                    <span className="swapPage__titleConverter">XLM converter</span>
                    <input
                        className="swapPage__inputAmountConverter"
                        value={inputValue}
                        type="text"  // Используем "text", чтобы полностью контролировать ввод
                        placeholder="BOM amount"
                        onChange={handleInputChange} // Обработчик изменения значения инпута
                        onKeyDown={handleKeyDown}
                        style={{
                            border: isInputValid ? '1px solid #232323' : '1px solid red', // Красная рамка при ошибке
                        }}
                    />
                    <div className="swapPage__balanceConverter">
                        <img src={resources.icons.bag} className="swapPage__iconConverter rewardCard__valueIcon" />
                        <span className="swapPage__textBalanceConverter">
                            {`${calculatedAmount ? formatNumberForXlmResult(calculatedAmount) : '0.00'} XLM`}
                        </span>
                    </div>
                    <img className="swapPage__iconSwap" src={resources.icons.icon_swap} />
                    <button className="swapPage__buttonConverter" onClick={main}>
                        <span className="swapPage__textButtonConverter">Submit</span>
                    </button>
                </div>
            </div>
        </div>
    );
}

export default Swap;
